<template>
    <div class="modal" :id="'editUserPermissionsModalFor' + parentId" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-custom">
            <div class="modal-content">
                <div class="modal-header bg-white">
                    <h5 class="modal-title text-teal font-medium">Edit {{ selectedUser ? selectedUser.name : '' }} permissions</h5>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body modal-scrollable">
                    <div class="row p-2">
                        <div class="col-12">
                            <choose-set-access
                                ref="ChooseSetAccess"
                                :team="team">
                            </choose-set-access>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click="close">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="updateUserPermissions">Update</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChoosePermissions from "../preset/choose-permissions.vue";
import ChooseSetAccess from "../preset/choose-set-access.vue";

export default {
    name: 'manage-user-permissions-modal',
    components: {ChooseSetAccess, ChoosePermissions},
    props: ['team', 'parentId'],
    data() {
        return {
            selectedUser: null
        }
    },
    methods: {
        open(user) {
            this.selectedUser = user;
            this.$refs.ChooseSetAccess.$refs.ChoosePermissions.mapSavedPermissions(user.permissions);
            $("#editUserPermissionsModalFor" + this.parentId).modal("show");
        },
        close() {
            this.selectedUser = null;
            this.$refs.ChooseSetAccess.resetAllData();
            $("#editUserPermissionsModalFor" + this.parentId).modal("hide");
        },
        updateUserPermissions() {
            const payload = {
                userId: this.selectedUser.id,
                preset: this.$refs.ChooseSetAccess.selectedPreset,
                selectedPresetAccessType: this.$refs.ChooseSetAccess.selectedPresetAccessType,
                permissions: this.$refs.ChooseSetAccess.$refs.ChoosePermissions.selectedPermissions
            };

            axios.post('/settings/'+this.team.id+'/permissions/update/user-role-permissions', payload).then(({data}) => {
                this.$emit('user-permissions-updated');
                this.close();
                this.getToast().fire({
                    type: 'success',
                    title: 'User permissions updated successfully.'
                });
            });
        }
    }
}
</script>

<style scoped>
.card .custom-card-header {
    border-color: rgb(203, 214, 226);
    background-color: rgb(245, 248, 250);
    padding: .5rem .75rem;
    border-width: 1px 1px;
    border-bottom: none;
    border-radius: unset;
}
.card .custom-card-body {
    border-width: 1px 1px;
}
.custom-btn-link {
    text-decoration: none;
    box-shadow: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
}
.custom-btn-link:hover {
    text-decoration: none;
    color: #01B1AF;
}
.permission-card {
    border: 2px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
}
.permission-card:hover, .permission-card.active {
    border-color: #007bff;
    background-color: #f8f9fa;
}
.permission-card img {
    width: 50px;
    margin-bottom: 10px;
}
.radio-container {
    position: absolute;
    top: 10px;
    right: 10px;
}
.modal-fullscreen-custom {
    height: 100vh;
    display: flex;
    flex-direction: column;
    margin: 0;
    border: none;
    border-radius: 0;
    max-width: 100% !important;
}
.modal-fullscreen-custom .modal-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1051;
    height: 62px;
}
.modal-fullscreen-custom .modal-footer {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    z-index: 1051;
    height: 62px;
}
.modal-fullscreen-custom .modal-scrollable {
    overflow-y: auto;
    flex: 1 1 auto;
    margin-top: 70px;
    margin-bottom: 70px;
    padding: 15px;
}
.modal-fullscreen-custom .modal-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
}
.modal-fullscreen-custom .modal-header,
.modal-fullscreen-custom .modal-footer {
    flex-shrink: 0;
}
.modal-fullscreen-custom .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
}
</style>
